/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCarGeneric48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        fill='#D6F5FF'
        fillRule='evenodd'
        d='M9.576 14.715c7.325-3.293 16.492-4.956 26.714-5.684L24.21 8 11.633 9.29l-2.057 5.425zM23.998 28.38c4.893 0 6.851-.255 9.787-1.1 1.25 1.462 1.053 2.93 0 4.398h-9.787V28.38z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M39.68 37.922c1.81.486 3.731-.581 5.468-1.358l1.423-3.727v7.169a1.494 1.494 0 01-1.494 1.494h-3.902a1.494 1.494 0 01-1.494-1.494v-2.084z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M41.787 26.558c1.732 0 3.136-1.385 3.136-3.093s-1.404-3.093-3.136-3.093c-1.732 0-3.136 1.385-3.136 3.093s1.404 3.093 3.136 3.093zM41.767 17.794h0a5.478 5.478 0 00-5.32 4.171l-.622 2.531M43.868 15.732c.866 0 1.569-.692 1.569-1.546 0-.854-.703-1.546-1.569-1.546s-1.568.692-1.568 1.546c0 .854.702 1.546 1.568 1.546z'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M28.184 36.868h-3.659'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M37.072 32.228v-5.67'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M6.228 31.713c.577 0 1.046-.462 1.046-1.031 0-.57-.469-1.031-1.046-1.031-.577 0-1.045.462-1.045 1.031 0 .57.468 1.031 1.045 1.031zM43.576 15.934l-.23 1.86'
      />
      <path
        fill='#D6F5FF'
        fillRule='evenodd'
        d='M24.002 28.38c-4.893 0-6.851-.255-9.787-1.1-1.25 1.462-1.053 2.93 0 4.398h9.787V28.38z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M8.408 37.922c-1.81.486-3.73-.581-5.468-1.358l-1.422-3.526v6.968A1.494 1.494 0 003.012 41.5h3.902c.825 0 1.494-.669 1.494-1.494v-2.084z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M6.213 26.558c1.732 0 3.137-1.385 3.137-3.093s-1.405-3.093-3.137-3.093-3.136 1.385-3.136 3.093 1.404 3.093 3.136 3.093zM6.233 17.794h0a5.478 5.478 0 015.32 4.171l.622 2.531M4.132 15.732c.866 0 1.568-.692 1.568-1.546 0-.854-.702-1.546-1.568-1.546-.866 0-1.569.692-1.569 1.546 0 .854.703 1.546 1.569 1.546zM23.936 32.228h7.244a3.493 3.493 0 003.481-3.786l-.028-.326a3.401 3.401 0 00-2.314-2.941c-1.759-.561-4.579-1.195-8.383-1.195h.128c-3.804 0-6.624.634-8.382 1.199a3.398 3.398 0 00-2.311 2.938c-.014.106-.023.214-.032.325a3.494 3.494 0 003.48 3.786h7.245M28.185 19.341s-.919-.515-4.187-.515h.005c-3.269 0-4.187.515-4.187.515'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M40.036 18.043l-2.041.316a14.024 14.024 0 01-5.95-.36l-2.518-.71a14.032 14.032 0 00-3.803-.526h-1.727.006-1.727c-1.285 0-2.566.177-3.803.526l-2.518.71a14.024 14.024 0 01-5.95.36l-2.042-.316'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M41.71 17.794h.371A4.92 4.92 0 0147 22.715v7.863a6.807 6.807 0 01-6.806 6.806h-7.305c-.655 0-1.568 1.547-3.136 1.547H18.247c-1.569 0-2.481-1.547-3.136-1.547H7.806A6.807 6.807 0 011 30.577v-7.864a4.92 4.92 0 014.919-4.919h.372'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M19.816 36.868h3.66'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M10.928 32.228v-5.67'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M41.772 31.713c.578 0 1.046-.462 1.046-1.031 0-.57-.468-1.031-1.046-1.031-.577 0-1.045.462-1.045 1.031 0 .57.468 1.031 1.045 1.031z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M39.737 17.656l-3.392-7.496a1.86 1.86 0 00-.888-.91c-1.098-.259-4.076-.735-11.517-.735h.12c-7.44 0-10.419.476-11.511.746a1.848 1.848 0 00-.883.904c-.916 1.994-3.404 7.491-3.404 7.491'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M4.424 15.934l.23 1.86'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M36.313 18.015c-.686-2.68-2.82-4.19-5.684-3.839-1.625.2-3.005.945-3.845 1.95l-.695.92'
      />
    </svg>
  );
}

export default SvgCarGeneric48;
